<template>
  <div>
    <navbar></navbar>

    <div
      v-if="(isInprogressSignProcedure || isShowSepaBanner) && sepaPermission"
      class="subscribe-sepa-banner"
    >
      <span>
        {{
          isInprogressSignProcedure
            ? $t("sepa-procedure-is-in-progress")
            : $t("sepa-subscribe-credit-debit-title")
        }}
      </span>
      <span class="subsribe-sepa-link" href="#" @click="onConfirmSepa">{{
        isInprogressSignProcedure
          ? $t("sepa-sign-up-link")
          : $t("sepa-suscribe-link-title")
      }}</span>
    </div>

    <main role="main" class="container">
      <alerts></alerts>
      <slot></slot>
    </main>

    <app-footer></app-footer>
    <alerts-popup></alerts-popup>
    <b-modal
      id="confirmHomeSigningModal"
      class="modal-box"
      ref="confirmHomeSigningModal"
      hide-footer
      hide-header
      centered
      content-class="confirm-modal-content"
    >
      <div class="confirm-content">
        {{ $t("a-new-task-will-be-open-message") }}
      </div>
      <div class="mt-3 text-center">
        <b-button variant="outline-primary" @click="hideModal" class="mr-4">
          {{ $t("cancel-btn") }}
        </b-button>
        <b-button @click="onConfirmPopup" variant="primary">
          {{ $t("confirm-open-yousign-button") }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Navbar from "../components/_partials/Navbar.vue";
import AppFooter from "../components/_partials/Footer.vue";
import Alerts from "../components/_partials/Alerts.vue";
import AlertsPopup from "../components/_partials/AlertsPopup.vue";
import conditionHelper from "@/helpers/condition";
import { trackDisplayEvent, trackClickButton } from "../fire";
import { SCREEN_NAME, ACTION_KEY } from "../constants/firebase";
export default {
  components: {
    Navbar,
    AppFooter,
    Alerts,
    AlertsPopup
  },
  data() {
    return {
      isInprogressSignProcedure: false,
      isShowSepaBanner: false
    };
  },
  props: ["sepaStatus", "sepaStatusInfo"],
  computed: {
    sepaPermission() {
      return conditionHelper("rcfsepaclient");
    }
  },
  watch: {
    sepaStatusInfo(value) {
      if (
        !value.hasRibValid &&
        value.isEligibleToPrelevement &&
        (!value.signatureUrl || value.signatureUrl == null)
      ) {
        this.isInprogressSignProcedure = false;
        this.isShowSepaBanner = true;
        trackDisplayEvent(
          `${SCREEN_NAME.HOME_PAGE}_${ACTION_KEY.SUBSCRIBE_SEPA_DIRECT_DEBIT}`
        );
      } else {
        if (value.signatureUrl) {
          this.isInprogressSignProcedure = true;
          trackDisplayEvent(
            `${SCREEN_NAME.HOME_PAGE}_${ACTION_KEY.SEPA_BANNER_END_SUBSCRIPTIONS}`
          );
          this.isShowSepaBanner = false;
        } else {
          this.isInprogressSignProcedure = false;
          this.isShowSepaBanner = false;
        }
      }
    }
  },
  methods: {
    hideModal() {
      this.$bvModal.hide("confirmHomeSigningModal");
    },
    showConfirmPopup() {
      this.$bvModal.show("confirmHomeSigningModal");
    },
    onConfirmPopup() {
      if (this.sepaStatusInfo && this.sepaStatusInfo.signatureUrl !== null) {
        window.open(this.sepaStatusInfo.signatureUrl, "_blank");
      }
      this.hideModal();
    },
    onConfirmSepa() {
      if (this.isInprogressSignProcedure) {
        trackClickButton(
          `${SCREEN_NAME.HOME_PAGE}_${ACTION_KEY.SEPA_BANNER_END_SUBSCRIPTIONS}`
        );
        this.showConfirmPopup();
      } else {
        trackClickButton(
          `${SCREEN_NAME.HOME_PAGE}_${ACTION_KEY.SUBSCRIBE_SEPA_DIRECT_DEBIT}`
        );
        this.$router.push("/coordonnees");
        this.$store.commit("sepaCredit/SET_NAVIGATE_TO_SEPA", true);
      }
    }
  }
};
</script>

<style lang="scss">
$header-height: 66px;
$footer-height: 56px;

html {
  position: relative;
  min-height: 100%;
}
body {
  margin-bottom: $footer-height;
}
main {
  padding-top: $header-height - 45;
  position: relative;
}

.navbar {
  height: $header-height;
}
.c-main-nav {
  @media (max-width: 768px) {
    box-shadow: 0 0.5rem 1rem rgba(black, 0.5);
    margin-left: -16px;
    margin-right: -16px;
    padding-left: 16px;
  }
}
.c-subnav {
  @media (max-width: 575px) {
    background-color: #fff;
    box-shadow: 0 0.5rem 1rem rgba(black, 0.5);
    margin-left: -16px;
    margin-right: -16px;
    padding-left: 16px;
    z-index: 1;
  }
}
.c-footer {
  height: $footer-height;
  overflow: auto;
  position: absolute;
  bottom: 0;
  width: 100%;
}
.c-footer__info {
  color: white;
}

.subscribe-sepa-banner {
  background-image: url("../assets/background-subsribe-banner.png");
  padding: 12px 18px;
  background-repeat: no-repeat;
  object-fit: cover;
  font-size: 19px;
  color: white;
  vertical-align: middle;
  text-align: left;
  top: 66px;
  right: 0;
  left: 0;
  z-index: 1030;
  width: 100%;
  min-height: 56px;
  position: sticky;
  background-size: cover;
  background-position: center;
}

span.subsribe-sepa-link {
  color: white;
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
}

::v-deep {
  .confirm-modal-content {
    min-width: 400px;
    max-width: 500px;
    min-height: 100px;
    background: white;
    border: 1px solid;
    border-radius: 20px;
    padding: 25px;
    font-size: 20px;
  }
}
</style>
